import { CONSTANT } from '@/utils/constant'
import utils from '@/utils/utils'

export default class TraceService {
  /**
   * add request logs
   * @param providerName
   * @param methodName
   * @param params
   */
  static addRequestLogs ({ methodName, params = {}, providerName = '' }) {
    if (methodName) {
      let traceLogs = this.getTraceLog() || []
      let traceLogData = this.getTraceLogData(traceLogs) || []
      this.extracted(traceLogData, methodName, providerName)
      params = (typeof params !== 'string') ? params : JSON.parse(params)
      let currentObj = traceLogData[traceLogData.length - 1]
      if (!providerName || this.isBackendLog(methodName)) {
        currentObj['request'] = params
      } else {
        currentObj['request'][providerName] = params
      }
      traceLogData[traceLogData.length - 1] = currentObj
      this.setTraceLog(traceLogs, traceLogData)
    }
  }

  /**
   * Method for inserting new transaction on every init call
   */
  static setNewTransaction () {
    let traceLogs = this.getTraceLog() || []
    traceLogs.push({
      initiationTime: new Date(),
      data: []
    })
    localStorage.setItem('traceLog', JSON.stringify(Array.from(traceLogs)))
  }

  /**
   * common method to push logs detail
   * @param traceLogs
   * @param methodName
   * @param providerName
   */
  static extracted (traceLogs, methodName, providerName) {
    let currentObj = traceLogs[traceLogs.length - 1]
    if (traceLogs.length === 0 || currentObj.methodName !== methodName || !providerName) {
      traceLogs.push({ 'methodName': methodName, 'request': {}, 'response': {}, 'timeTaken': {} })
    } else {
      if (!(currentObj.methodName === methodName && (currentObj.request.hasOwnProperty(providerName)))) {
        return
      }
      traceLogs.push({ 'methodName': methodName, 'request': {}, 'response': {}, 'timeTaken': {} })
    }
  }

  /**
   * add response logs
   * @param methodName
   * @param params
   * @param providerName
   */
  static addResponseLogs (methodName, params, providerName) {
    let traceLogs = this.getTraceLog() || []
    let traceLogData = this.getTraceLogData(traceLogs) || []
    params = (typeof params !== 'string') ? params : JSON.parse(params)
    let currentObj
    if (methodName) {
      for (let i = traceLogData.length - 1; i >= 0; i--) {
        if (traceLogData[i].methodName === methodName) {
          currentObj = traceLogData[i]
          if (!providerName || this.isBackendLog(methodName)) {
            currentObj.response = params
          } else {
            currentObj.response[providerName] = params
          }
          traceLogData[i] = currentObj
          this.setTraceLog(traceLogs, traceLogData)
          break
        }
      }
    }
  }

  /**
   * add time taken
   * @param methodName
   * @param params
   * @param providerName
   */
  static addTimeTaken (methodName, params, providerName) {
    let traceLogs = this.getTraceLog() || []
    let traceLogData = this.getTraceLogData(traceLogs) || []
    if (traceLogData) {
      for (let i = traceLogData.length - 1; i >= 0; i--) {
        if (traceLogData[i].methodName === methodName) {
          if (providerName) {
            traceLogData[i].timeTaken[providerName] = params
          } else {
            traceLogData[i].timeTaken = params
          }
          this.setTraceLog(traceLogs, traceLogData)
          break
        }
      }
    }
  }

  /* eslint complexity: ["error", 10] */
  /**
   * update call traces for backend logs
   * @param providerName
   * @param callTraces
   */
  static updateCallTraces (providerName, callTraces, success = true) {
    if (typeof callTraces === 'undefined' || callTraces === null || callTraces.length < 1) {
      return
    }
    for (let index = 0; index < callTraces.length; index++) {
      const callTrace = callTraces[index]
      this.addRequestLogs({
        providerName,
        methodName: callTrace.url,
        params: callTrace.requestBody
      })
      if (success) {
        this.addResponseLogs(callTrace.url, callTrace.responseBody, providerName)
      } else {
        this.addResponseLogs(callTrace.url, this.getCallTrace(callTrace), providerName)
      }
      if (callTrace.startTime) {
        const timeTakenData = utils.getTimeTakenDetail(
          new Date(callTrace.startTime),
          callTrace.endTime ? new Date(callTrace.endTime) : CONSTANT.ERROR_MSG.apiFailureMsg
        )
        this.addTimeTaken(callTrace.url, timeTakenData, providerName.toUpperCase() + ' ' + 'NETWORK')
      }
    }
  }

  /**
   * verify backend logs
   * @param methodName
   * @returns {boolean}
   */
  static isBackendLog (methodName) {
    return (
      methodName.indexOf('Decrypted Payload') > -1 ||
        methodName.indexOf('confirmations') > -1 ||
        methodName.indexOf('wallet/payments') > -1 ||
        methodName.indexOf('srcspayload-qa.americanexpress.com')) > -1 ||
      this.getPayloadApi(methodName) || this.getSCOFApi(methodName)
  }

  /**
   * verify backend logs for transaction API
   * @param methodName
   * @returns {boolean}
   */
  static getPayloadApi (methodName) {
    return (methodName.indexOf('transactionCredentials') > -1 ||
      methodName.indexOf('transaction/credentials') > -1 ||
      methodName.indexOf('transaction') > -1 ||
      methodName.indexOf('amex/transaction') > -1)
  }

  /**
   * verify backend logs for SCOF API
   * @param methodName
   * @returns {boolean}
   */
  static getSCOFApi (methodName) {
    return (methodName.indexOf('authentications/authenticators') > -1 ||
      methodName.indexOf('payments/cards') > -1)
  }

  /**
   * Log Call Traces
   * @param callTraces
   * @returns {{callTrace: {body: (*), message: (*), transactionId: string, status: (*)}}}
   */
  static getCallTrace (callTraces) {
    let responseBody = JSON.parse(callTraces.responseBody) || {}
    if (responseBody.body) {
      return {
        callTrace: {
          body: responseBody.body,
          message: responseBody.body.message ? responseBody.body.message : callTraces.message,
          status: responseBody.body.status ? responseBody.body.status : responseBody.body.code
        }
      }
    } else {
      return responseBody
    }
  }

  /**
   * get trace logs from local
   * @returns {any}
   */
  static getTraceLog () {
    let traceLog = JSON.parse(localStorage.getItem('traceLog')) || []
    return traceLog
  }

  /**
   * get trace log data from trace logs
   * @returns {any}
   */
  static getTraceLogData (traceLog) {
    let traceLogData = traceLog[traceLog.length - 1] || {}
    traceLogData = traceLogData.data || []
    return traceLogData
  }

  /**
   * set trace logs in local
   * @param traceLog
   */
  static setTraceLog (traceLogs, traceLogData) {
    if (traceLogs.length <= 0) {
      traceLogs = [
        { data: [] }
      ]
    }
    traceLogs[traceLogs.length - 1].data = Array.from(traceLogData)
    localStorage.setItem('traceLog', JSON.stringify(Array.from(traceLogs)))
  }
}
